export const planDetailsContent = {
  ctaDataItemName: 'how-it-works-order',
  ctaViewAll: 'View all plans',
  ctaViewAllDataName: 'pdp-view-all-plans',
}
